import { Modal } from "antd";
import type React from "react";
import { useAudienceModalContext } from "../../providers/AudienceModalContext";
import type { AudienceModalStep } from "../../types";

type AudienceModalWidthTypeMap = Partial<Record<AudienceModalStep, number>>;

export interface AudienceModalContainerProps {
	children: React.ReactNode;
	title?: string;
	width?: number | AudienceModalWidthTypeMap;
}

const DEFAULT_MODAL_WIDTH = 800;

const isAudienceModalWidthTypeMap = (
	width: number | AudienceModalWidthTypeMap,
): width is AudienceModalWidthTypeMap => {
	return !Number.isNaN(width);
};

const AudienceModalContainer: React.FC<AudienceModalContainerProps> = ({
	children,
	title,
	width = DEFAULT_MODAL_WIDTH,
}) => {
	const { visible, onClose, step } = useAudienceModalContext();

	const modalTitle =
		title ||
		(step === "edit"
			? "オーディエンスの編集"
			: step === "view"
				? "オーディエンスの詳細"
				: "新しいオーディエンスの作成");

	const modalWidth =
		isAudienceModalWidthTypeMap(width) && step
			? width[step] || DEFAULT_MODAL_WIDTH
			: (width as number);

	return (
		<Modal
			title={modalTitle}
			open={visible}
			onCancel={onClose}
			footer={null}
			destroyOnClose
			centered
			width={modalWidth}
			styles={{
				body: {
					maxHeight: "80vh",
					overflowY: "auto",
				},
			}}
		>
			{children}
		</Modal>
	);
};

export default AudienceModalContainer;
